// index-distribution.ts
// Favicons
import '@/favicon/android-chrome-192x192.png';
import '@/favicon/android-chrome-512x512.png';
import '@/favicon/apple-touch-icon.png';
import '@/favicon/favicon-16x16.png';
import '@/favicon/favicon-32x32.png';
import '@/favicon/favicon.ico';
import '@/favicon/mstile-150x150.png';
import '@/favicon/mstile-150x150.png';
import '@/favicon/safari-pinned-tab.svg';
import '@/favicon/browserconfig.xml';
import '@/favicon/site.webmanifest';
// Styles
import '@/styles/main-distribution';
// Icon Sprite
// SSEN Logos
import '@/icons/SSEN/SSEN-logo-strapline.svg';
import '@/icons/SSEN/SSEN-logo.svg';
import '@/icons/SSEN/SSEN-logomark.svg';
import '@/icons/SSEN/SSEN-motif-dots.svg';
import '@/icons/SSEN/SSEN-motif-sidebar.svg';
import '@/icons/SSEN/power-cut.svg';
// Component-specific icons
// Shared icons
import '@/icons/components/_shared/bsl.svg';
import '@/icons/components/_shared/faqs.svg';
import '@/icons/components/_shared/meter-services.svg';
import '@/icons/components/_shared/pointer-click.svg';
// Shared - Socials - footer & social share components
import '@/icons/components/_shared/social/facebook-circled.svg';
import '@/icons/components/_shared/social/instagram-circled.svg';
import '@/icons/components/_shared/social/linkedin-circled.svg';
import '@/icons/components/_shared/social/mail-circled.svg';
import '@/icons/components/_shared/social/twitter-x-circled.svg';
import '@/icons/components/_shared/social/whatsapp-circled.svg';
import '@/icons/components/_shared/social/youtube-circled.svg';
// Shared - File types - Document download + library components
import '@/icons/components/_shared/file-types/csv.svg';
import '@/icons/components/_shared/file-types/doc.svg';
import '@/icons/components/_shared/file-types/file.svg';
import '@/icons/components/_shared/file-types/pdf.svg';
import '@/icons/components/_shared/file-types/ppt.svg';
import '@/icons/components/_shared/file-types/xlsx.svg';
import '@/icons/components/_shared/file-types/zip.svg';
// Category Listing Component
import '@/icons/components/category-listing/connect-developers.svg';
import '@/icons/components/category-listing/disconnection-assist.svg';
import '@/icons/components/category-listing/documents.svg';
import '@/icons/components/category-listing/unmetered-connections.svg';
import '@/icons/components/category-listing/upgrade-your-supply.svg';
// Contact Card Component
import '@/icons/components/contact-card/contact-email.svg';
import '@/icons/components/contact-card/contact-fb-messenger.svg';
import '@/icons/components/contact-card/contact-tel.svg';
import '@/icons/components/contact-card/contact-twitter-x.svg';
import '@/icons/components/contact-card/contact-textphone.svg';
import '@/icons/components/contact-card/contact-url.svg';
import '@/icons/components/contact-card/contact-whatsapp.svg';
// Contact Triage Component
import '@/icons/components/contact-triage/emergencies.svg';
import '@/icons/components/contact-triage/make-a-complaint.svg';
import '@/icons/components/contact-triage/press-office.svg';
import '@/icons/components/contact-triage/priority-services.svg';
import '@/icons/components/contact-triage/social-media.svg';
// Connections Triage Component
import '@/icons/components/connections-triage/electric-vehicle.svg';
import '@/icons/components/connections-triage/fuel-cells.svg';
import '@/icons/components/connections-triage/heat-pump.svg';
import '@/icons/components/connections-triage/inside-home.svg';
import '@/icons/components/connections-triage/outside-boundary.svg';
import '@/icons/components/connections-triage/outside-home.svg';
import '@/icons/components/connections-triage/overhead-wire.svg';
import '@/icons/components/connections-triage/single-phase.svg';
import '@/icons/components/connections-triage/solar.svg';
import '@/icons/components/connections-triage/three-phase.svg';
import '@/icons/components/connections-triage/under-cable.svg';
// General icons
import '@/icons/arrow-left.svg';
import '@/icons/arrow-right.svg';
import '@/icons/arrow-right-long.svg';
import '@/icons/burger-menu.svg';
import '@/icons/circle-solid.svg';
import '@/icons/close.svg';
import '@/icons/cross-circled.svg';
import '@/icons/down-arrow.svg';
import '@/icons/download.svg';
import '@/icons/email.svg';
import '@/icons/help.svg';
import '@/icons/info.svg';
import '@/icons/info-filled.svg';
import '@/icons/warning-filled.svg';
import '@/icons/minus.svg';
import '@/icons/next.svg';
import '@/icons/personal.svg';
import '@/icons/phone.svg';
import '@/icons/play.svg';
import '@/icons/plus.svg';
import '@/icons/prev.svg';
import '@/icons/quotemark.svg';
import '@/icons/search.svg';
import '@/icons/tick-circled.svg';
import '@/icons/tick.svg';
import '@/icons/visibility--off.svg';
import '@/icons/visibility.svg';
// Images
import '@/images/jpg/card-default.jpg';
import '@/images/jpg/desktop-banner.jpg';
import '@/images/png/lazy-load-placeholder.png';
import '@/images/jpg/maintenance.jpg';
import '@/images/png/power.png';
import '@/images/png/SSEN-logo.png';
// Scripts
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'regenerator-runtime/runtime';
import polyfill from '@/scripts/lib/polyfill';
import accessibility from '@/scripts/lib/accessibility';
import analytics from '@/scripts/analytics/analytics';
import moduleLoader from '@/scripts/module-loader-distribution';
document.addEventListener('DOMContentLoaded', function () {
    document.getElementsByTagName('html')[0].classList.remove('no-js');
    // Lib
    polyfill.polyfillClosest();
    polyfill.polyfillRemove();
    accessibility();
    analytics();
    // ES6 modules loaded dynamically based on DOM query
    var modules = Array.from(document.querySelectorAll('.js-module'));
    moduleLoader(modules);
}, false);
